const SETS = [
    [
        ['magnify', 'at', 'lambda', 'lightning', 'yield', 'hj', 'revc'],
        ['Look', 'at', 'lamb', 'light,', 'stop', 'his', 'cat']
    ],
    [
        [
            'reve',
            'magnify',
            'revc',
            'loopty',
            'emptystar',
            'hj',
            'questionmark'
        ],
        ['Ey', 'look', 'see', 'shooting', 'star', 'huh', '?']
    ],
    [
        [
            'copy',
            'comma',
            'loopty',
            'mirroredk',
            'threefizzle',
            'lambda',
            'emptystar'
        ],
        ['Cops', 'will', 'circle', 'my', 'three', 'lamb', 'stars']
    ],
    [
        [
            'six',
            'paragraph',
            'bt',
            'yield',
            'mirroredk',
            'questionmark',
            'smiley'
        ],
        ['Six', 'par-', 'ties', 'stop', 'my', 'questions', 'happily']
    ],
    [
        [
            'trident',
            'smiley',
            'bt',
            'cdot',
            'paragraph',
            'threeears',
            'filledstar'
        ],
        ['Try', 'smiling', 'be-', 'cause', 'par', 'three', 'stars']
    ],
    [
        ['six', 'reve', 'notequals', 'ae', 'trident', 'revn', 'omega'],
        ['Sax-', 'E (saxy)', 'not', 'a', 'try', 'no-', 'mega']
    ]
];

export default SETS;
